export const HIDE_APP_OFFLINE_STATUS_BAR = 'app/HIDE_APP_OFFLINE_STATUS_BAR';
